<template>
  <TopGradientBlockLayout v-if="dataFetched" fit-content>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <div v-if="!openForm" class="flex items-center justify-between">
        <BaseButton @click="openForm=true"
                    theme="red"
                    class="w-91">
          {{ $t('createExpense') }}
        </BaseButton>
        <ExpenseSpaceSettings/>
      </div>
      <ExpenseSettingsForm @expenseCreated="updateExpenses" @expenseGroupCreated="updateExpenses" v-else/>
    </template>
    <ExpenseList
                 ref="list"
                 @edit="openEditExpenseModal"
                 @editGroup="openEditGroupModal"/>
    <transition name="modal">
      <ExpenseGroupEditModal v-if="!!edit_group"
                             :group="edit_group"
                             @close="handleCloseEditExpenseGroupModal"/>
      <ExpenseSettingsEditModal v-if="!!edit_expense"
                                :edit_expense="edit_expense"
                                @close="handleCloseEditExpenseModal"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import ExpenseSettingsForm from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettingsForm";
import ExpenseList from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseList";
import ExpenseSettingsEditModal from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSettingsEditModal";
import ExpenseGroupEditModal from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseGroupEditModal";
import ExpenseSpaceSettings from "@/components/cabinet/SpaceSettings/ExpenseSettings/ExpenseSpaceSettings";

export default {
  name: "ExpenseSettings",
  components: {
    ExpenseSpaceSettings,
    TopGradientBlockLayout,
    ExpenseGroupEditModal,
    ExpenseSettingsForm,
    ExpenseSettingsEditModal,
    ExpenseList,
    BaseButton,
  },
  computed: {
    ...mapState('space/expenses', ['expenses', 'expense_groups']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  data() {
    return {
      dataFetched: false,
      openForm: false,
      edit_expense: null,
      edit_group: null
    }
  },
  methods: {
    openEditExpenseModal(val) {
      this.edit_expense = val;
    },
    handleCloseEditExpenseModal() {
      this.edit_expense = null;
      this.updateExpenses();
    },
    handleCloseEditExpenseGroupModal() {
      this.edit_group = null
      this.updateExpenses();
    },
    openEditGroupModal(val) {
      this.edit_group = val;
    },
    async updateExpenses() {
      await this.$store.dispatch('space/expenses/getExpenses');
      await this.$store.dispatch('space/expenses/getExpenseGroups');
      this.$refs.list.setListing();
    },
    async fetchMainData() {
      try {
        await this.$store.dispatch('space/expenses/getExpenses');
        await this.$store.dispatch('space/expenses/getExpenseGroups');
      } catch (e) {
        throw e;
      }
    }
  },
  async created() {
    await this.fetchMainData()
    this.dataFetched = true;
  },
  i18n: {
    messages: {
      en: {
        createExpense: 'Create expense category'
      },
      ru: {
        createExpense: 'Создать категорию расхода'
      }
    }
  }
}
</script>
